import { AdminSettingsFormWrapper } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';
import * as yup from 'yup';
import { FormContent } from './components/FormContent';
import { useGetAdminSettings } from '../../../../queries';
import { AdminSettingsResponse } from '../../../types';
import {
  transformAdminSettingsToFormValues,
  transformAdminSettingsToRequestValues
} from '../../../utils';

import { useSaveResource } from 'RestAPIs/useSaveResource';
import { ADMIN_SETTINGS_GROUP } from 'RestAPIs/endpoints';

const schema = yup.object({
  self_match_flex_match_connect: yup.boolean(),
  self_match: yup.string(),
  self_match_roster_match_connect: yup.boolean(),
  self_match_flex_deployableasflex_action: yup.string(),
  self_match_automatic_publish_preference2_action: yup.string(),
  self_match_automatic_visible_preference1_action: yup.string(),
  self_match_automatic_publish_own_action: yup.string(),
  self_match_automatic_publish_shared_action: yup.string(),
  self_match_automatic_visible_own_action: yup.string(),
  self_match_automatic_visible_shared_action: yup.string(),
  self_match_automatic_publish_preference1_action: yup.string(),
  self_match_automatic_visible_preference2_action: yup.string(),
  self_match_ignore_negative_balance: yup.boolean(),
  self_match_flex_preference1_action: yup.string(),
  self_match_flex_deployableasflexpreference1_action: yup.string(),
  self_match_flex_flex_action: yup.string()
});

export const MATCH_SETTINGS_GROUP = 'self-match';

const MatchSettings = () => {
  const { data: matchSettings = [], isFetching } =
    useGetAdminSettings<AdminSettingsResponse>(MATCH_SETTINGS_GROUP);

  const { mutate: saveMatchSetting } = useSaveResource({
    url: ADMIN_SETTINGS_GROUP,
    id: matchSettings[0]?.groupId
  });

  const onSubmit = async (formData) => {
    saveMatchSetting({
      ...matchSettings[0],
      settings: transformAdminSettingsToRequestValues(
        formData,
        matchSettings[0].settings
      ),
      active: matchSettings[0].active
    });
  };

  return (
    <AdminSettingsFormWrapper
      submitForm={onSubmit}
      schema={schema}
      fixedHeightForm={false}
      isLoading={false}
      data={transformAdminSettingsToFormValues(matchSettings[0])}
      isFetching={isFetching}
    >
      <FormContent />
    </AdminSettingsFormWrapper>
  );
};

export default MatchSettings;
